<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#BB6BD9"/>
    <path d="M7 6.68286L7 4.68286C10.0251 3.79549 11.7506 3.74957 15 4.68286L15 6.68286C11.8258 5.79053 10.0543 5.85986 7 6.68286ZM12 16.6929L12 8.68286L10 8.68286L10 16.6929L7 16.6929L11 20.6829L15 16.6929L12 16.6929Z" fill="#F2F2F2"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.59 13.09L16.5 15.5L15.41 13.09L13 12L15.41 10.91L16.5 8.5L17.59 10.91L20 12L17.59 13.09Z" fill="#F2F2F2"/>
  </svg>
</template>

<script>
export default {
  name: "Multiselect"
}
</script>

<style scoped>

</style>
